import Home from '@/components/pages/Home'
import ContactUs from '@/components/pages/ContactUs'
import Portfolio from '@/components/pages/Portfolio'
import OurServices from '@/components/pages/OurServices'
import TermsOfUse from '@/components/pages/TermsOfUse'
import Testimonials from '@/components/pages/Testimonies'

/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * NOTE: When adding new routes, due to an issue with the vue-prerender
 * plugin, the routes need to be manually added to build/build.js. In
 * there there is a list of URLs to pre-render on deployment.
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
*/
export default [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/portfolio/',
    name: 'portfolio',
    component: Portfolio,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/our-services/',
    name: 'our-services',
    component: OurServices,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/contact-us/',
    name: 'contact-us',
    component: ContactUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/testimonials/',
    name: 'testimonials',
    component: Testimonials,
    pathToRegexpOptions: { strict: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js